import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigDto, SampleDetailsDto } from '@src/types/types.ts';
import { ErrorContent } from '@components/atoms/ErrorContent.tsx';
import {
  areAllAnalysable,
  categorizedParameters,
  hasInfoToShow,
} from '@src/asbestos/utils.ts';
import { AsbestosParameterInfoOverlay } from '@src/asbestos/components/AsbestosParameterInfoOverlay.tsx';
import {
  AsbestosUpselling,
  KmfUpselling,
} from '@src/asbestos/components/AsbestosUpselling.tsx';
import { KmfSection } from '@src/asbestos/components/KmfSection';
import { AsbestosSection } from '@src/asbestos/components/AsbestosSection.tsx';

export const AsbestosResults = ({
  sample,
  configuration,
  backToProfile,
}: {
  sample: SampleDetailsDto;
  configuration: ConfigDto;
  backToProfile?: () => void;
}) => {
  const { t: tError } = useTranslation('component', {
    keyPrefix: 'parameterList.asbestosAnalysisError',
  });
  const [popupPmId, setPopupPmId] = useState<string | null>(null);

  if (!areAllAnalysable(sample) || !hasInfoToShow(sample)) {
    console.error(
      "Sample has no analyzable asbestos or kmf parameters, couldn't show results",
      sample.code,
    );
    return (
      <div className="space-y-6">
        <ErrorContent
          fullScreen={false}
          backToProfile={tError('backToProfile')}
          title={tError('title')}
          description={tError('description')}
          goBack={backToProfile ?? (() => {})}
        />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <AsbestosSection
        sample={sample}
        onInfoTap={() => {
          setPopupPmId(
            categorizedParameters(sample).asbestosParam[0]?.rawParameter.pmId,
          );
        }}
        configuration={configuration}
      />
      <KmfSection
        sample={sample}
        onInfoTap={() => {
          setPopupPmId(
            categorizedParameters(sample).kmfParam[0]?.rawParameter.pmId,
          );
        }}
        configuration={configuration}
      />

      <AsbestosUpselling sample={sample} />
      <KmfUpselling sample={sample} />

      <AsbestosParameterInfoOverlay
        sample={sample}
        onClose={() => {
          setPopupPmId(null);
        }}
        pmId={popupPmId}
      />
    </div>
  );
};
